// extracted by mini-css-extract-plugin
export var menuIcon = "_pd-0";
export var menuIconInline = "_pd-1";